<script lang="ts">
  let { intense = false }: { intense?: boolean } = $props()
</script>

<!-- A slowly rotating fan of light rays behind the revealed item. -->
<div class="rays" class:intense aria-hidden="true"></div>

<style lang="postcss">
  .rays {
    position: absolute;
    top: 50%;
    left: 50%;
    animation: rays-rotation 90s linear infinite;
    margin: -80vmax;
    background: repeating-conic-gradient(
      color-mix(in oklab, var(--reveal-hue) 13%, transparent) 0deg 9deg,
      transparent 9deg 24deg
    );
    aspect-ratio: 1;
    width: 160vmax;
    pointer-events: none;
    mask-image: radial-gradient(
      closest-side,
      black 0%,
      black 20%,
      transparent 65%
    );
    &.intense {
      animation-duration: 60s;
      /* The period must divide 360 evenly (here: 20 rays × 18deg), otherwise
         the pattern wraps with a visible seam. */
      background: repeating-conic-gradient(
        color-mix(in oklab, var(--reveal-hue) 22%, transparent) 0deg 6deg,
        transparent 6deg 18deg
      );
    }
  }
  @keyframes rays-rotation {
    to {
      transform: rotate(360deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .rays {
      animation: none;
    }
  }
</style>
